<div class="root">
  <div class="budget-item income" (click)="onCardClick()"
    [ngClass]="{ 'income': item.amount >=0, 'expenses': item.amount < 0 }">
    <div class="description">
      <p>{{ item.description }}</p>
    </div>
    <div class="amount">
      <p>{{ item.amount }}</p>
    </div>
  </div>

  <div class="x-icon-button" (click)="onXButtonClick()"></div>
</div>
